export enum FetchXMLTemplateNamesSource {
OpportunityServicesForSecondaryAssignment = 'OpportunityServicesForSecondaryAssignment',
OpportunityServicesForContinuanceEngagement = "OpportunityServicesForContinuanceEngagement"
}